import { FeatureFlags } from '../../ts/FeatureFlags';
import { UpdateMetricsDataAction, UpdateMetricsData, ReplaceMetricDataRefreshListAction, ReplaceMetricDataRefreshList } from '../actions/UpdateMetricsActions';
import { MetricRefreshList } from '../state/MetricsDataState';
import { SetPreviousUrlAction } from '../../app/actions/spaces/SetPreviousUrlReducerAction';
import { SetPreviousUrl } from '../../app/actions/AppActionTypes';

// The max size of the list used to track the metrics that should be updated
export const METRIC_REFRESH_LIST_SIZE = 100;

export const metricsRefreshListReducer = (
  state: MetricRefreshList = [],
  action?: UpdateMetricsDataAction | ReplaceMetricDataRefreshListAction | SetPreviousUrlAction
): MetricRefreshList => {
  if (FeatureFlags.metricsAutoUpdateEnabled) {
    switch (action?.type) {
      case UpdateMetricsData: {
        const idsToLoad = action.metrics;
        if (idsToLoad.length !== 0) {
          const metricsToRefresh = state.filter(id => !idsToLoad.includes(id));
          const metricRefreshList = idsToLoad.concat(metricsToRefresh).slice(0, METRIC_REFRESH_LIST_SIZE);
          return metricRefreshList;
        }
        else {
          return state;
        }
      }
      case ReplaceMetricDataRefreshList: {
          return action.ids;
      }
      case SetPreviousUrl: {
        //clear out the refresh list when switching to a new url
        return [];
      }
      case undefined:
      default:
        return state;
    }
  }
  else {
    return state;
  }
};